var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { NullValue } from './struct.enums';
export function nullValueFromJSON(object) {
    switch (object) {
        case 0:
        case 'NULL_VALUE':
            return NullValue.NULL_VALUE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return NullValue.UNRECOGNIZED;
    }
}
export function nullValueToJSON(object) {
    switch (object) {
        case NullValue.NULL_VALUE:
            return 'NULL_VALUE';
        default:
            return 'UNKNOWN';
    }
}
var baseStruct = {};
export var Struct = {
    fromJSON: function (object) {
        var message = __assign({}, baseStruct);
        message.fields = {};
        if (object.fields !== undefined && object.fields !== null) {
            Object.entries(object.fields).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                message.fields[key] = Value.fromJSON(value);
            });
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        obj.fields = {};
        if (message.fields) {
            Object.entries(message.fields).forEach(function (_a) {
                var k = _a[0], v = _a[1];
                obj.fields[k] = Value.toJSON(v);
            });
        }
        return obj;
    },
};
var baseStruct_FieldsEntry = { key: '' };
export var Struct_FieldsEntry = {
    fromJSON: function (object) {
        var message = __assign({}, baseStruct_FieldsEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = String(object.key);
        }
        else {
            message.key = '';
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = Value.fromJSON(object.value);
        }
        else {
            message.value = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined &&
            (obj.value = message.value ? Value.toJSON(message.value) : undefined);
        return obj;
    },
};
var baseValue = {};
export var Value = {
    fromJSON: function (object) {
        var message = __assign({}, baseValue);
        if (object.nullValue !== undefined && object.nullValue !== null) {
            message.nullValue = nullValueFromJSON(object.nullValue);
        }
        else {
            message.nullValue = undefined;
        }
        if (object.numberValue !== undefined && object.numberValue !== null) {
            message.numberValue = Number(object.numberValue);
        }
        else {
            message.numberValue = undefined;
        }
        if (object.stringValue !== undefined && object.stringValue !== null) {
            message.stringValue = String(object.stringValue);
        }
        else {
            message.stringValue = undefined;
        }
        if (object.boolValue !== undefined && object.boolValue !== null) {
            message.boolValue = Boolean(object.boolValue);
        }
        else {
            message.boolValue = undefined;
        }
        if (object.structValue !== undefined && object.structValue !== null) {
            message.structValue = Struct.fromJSON(object.structValue);
        }
        else {
            message.structValue = undefined;
        }
        if (object.listValue !== undefined && object.listValue !== null) {
            message.listValue = ListValue.fromJSON(object.listValue);
        }
        else {
            message.listValue = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nullValue !== undefined &&
            (obj.nullValue =
                message.nullValue !== undefined ? nullValueToJSON(message.nullValue) : undefined);
        message.numberValue !== undefined && (obj.numberValue = message.numberValue);
        message.stringValue !== undefined && (obj.stringValue = message.stringValue);
        message.boolValue !== undefined && (obj.boolValue = message.boolValue);
        message.structValue !== undefined &&
            (obj.structValue = message.structValue ? Struct.toJSON(message.structValue) : undefined);
        message.listValue !== undefined &&
            (obj.listValue = message.listValue ? ListValue.toJSON(message.listValue) : undefined);
        return obj;
    },
};
var baseListValue = {};
export var ListValue = {
    fromJSON: function (object) {
        var message = __assign({}, baseListValue);
        message.values = [];
        if (object.values !== undefined && object.values !== null) {
            for (var _i = 0, _a = object.values; _i < _a.length; _i++) {
                var e = _a[_i];
                message.values.push(Value.fromJSON(e));
            }
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        if (message.values) {
            obj.values = message.values.map(function (e) { return (e ? Value.toJSON(e) : undefined); });
        }
        else {
            obj.values = [];
        }
        return obj;
    },
};
//# sourceMappingURL=struct.js.map